var _path, _path2, _mask, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3C0.5 1.61929 1.61929 0.5 3 0.5H10C11.3807 0.5 12.5 1.61929 12.5 3V7C12.5 8.38071 11.3807 9.5 10 9.5H3C1.61929 9.5 0.5 8.38071 0.5 7V3Z",
    stroke: "#FF563D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7C2.5 7.27614 2.72386 7.5 3 7.5C3.27614 7.5 3.5 7.27614 3.5 7H2.5ZM3.5 3C3.5 2.72386 3.27614 2.5 3 2.5C2.72386 2.5 2.5 2.72386 2.5 3H3.5ZM3.5 7V3H2.5V7H3.5Z",
    fill: "#FF563D"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_272_7191",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2.83594H15C15.5523 2.83594 16 3.33087 16 3.94141V6.15234C16 6.76288 15.5523 7.25781 15 7.25781H13M3 7.25781V2.83594Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1.83594C12.4477 1.83594 12 2.28365 12 2.83594C12 3.38822 12.4477 3.83594 13 3.83594V1.83594ZM13 6.25781C12.4477 6.25781 12 6.70553 12 7.25781C12 7.8101 12.4477 8.25781 13 8.25781V6.25781ZM2 7.25781C2 7.8101 2.44772 8.25781 3 8.25781C3.55228 8.25781 4 7.8101 4 7.25781H2ZM4 2.83594C4 2.28365 3.55228 1.83594 3 1.83594C2.44772 1.83594 2 2.28365 2 2.83594H4ZM13 3.83594H15V1.83594H13V3.83594ZM15 3.83594C14.9866 3.83594 14.9739 3.83253 14.9657 3.82868C14.9586 3.82535 14.9597 3.8241 14.9655 3.83057C14.978 3.84439 15 3.88083 15 3.94141H17C17 2.87529 16.1965 1.83594 15 1.83594V3.83594ZM15 3.94141V6.15234H17V3.94141H15ZM15 6.15234C15 6.21292 14.978 6.24936 14.9655 6.26318C14.9597 6.26965 14.9586 6.2684 14.9657 6.26507C14.9739 6.26122 14.9866 6.25781 15 6.25781V8.25781C16.1965 8.25781 17 7.21846 17 6.15234H15ZM15 6.25781H13V8.25781H15V6.25781ZM4 7.25781V2.83594H2V7.25781H4Z",
    fill: "#FF563D",
    mask: "url(#path-3-inside-1_272_7191)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.65e05a558f5fdf81359c1be2534992db.svg";
export { ForwardRef as ReactComponent };